import { render, staticRenderFns } from "./teacherAdd.vue?vue&type=template&id=7c674e4e&scoped=true&"
import script from "./teacherAdd.vue?vue&type=script&lang=js&"
export * from "./teacherAdd.vue?vue&type=script&lang=js&"
import style0 from "./teacherAdd.vue?vue&type=style&index=0&id=7c674e4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c674e4e",
  null
  
)

export default component.exports